var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E64A19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 12c.552 0 1 .453 1 .997v6.006c0 .511-.383.933-.883.99L10 20c-.552 0-1-.453-1-.997v-6.006c0-.511.383-.933.883-.99L10 12zm4 3.988c.552 0 1 .448 1 1V19c0 .552-.448 1-1 1s-1-.448-1-1v-2.012c0-.552.448-1 1-1zM10 8c2.762 0 5 2.238 5 5 0 .553-.448 1-1 1s-1-.447-1-1c0-1.657-1.343-3-3-3-1.654 0-3 1.344-3 2.997V19c0 .552-.448 1-1 1s-1-.448-1-1v-6.003C5 10.238 7.242 8 10 8zm0-4c4.972 0 9 4.03 9 9.005V16c0 .552-.448 1-1 1s-1-.448-1-1v-2.995C17 9.134 13.867 6 10 6c-.588 0-1.165.072-1.724.214-.535.135-1.08-.189-1.215-.724-.135-.536.189-1.08.724-1.215C8.504 4.093 9.246 4 10 4zM3.389 6.894c.375-.406 1.007-.43 1.413-.056.406.375.43 1.007.056 1.413C3.67 9.537 3 11.216 3 13.004V16c0 .552-.448 1-1 1s-1-.448-1-1v-2.996c0-2.296.863-4.458 2.389-6.11zM10 0c3.783 0 7.306 1.626 9.758 4.41.365.414.325 1.046-.09 1.411-.414.365-1.046.325-1.41-.09C16.18 3.376 13.202 2 10 2 6.814 2 3.85 3.36 1.775 5.694c-.367.412-.999.45-1.412.083-.412-.367-.45-1-.082-1.412C2.73 1.608 6.237 0 10 0z",
    transform: "translate(-300 -531) translate(298 529) translate(2 2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.dd6ee77ababe34af7b90387fe0b5abf2.svg";
export { ForwardRef as ReactComponent };